import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';

import { useUserHasPermission } from '@/hooks/usePermissions';

export const useCanUpdateAccount = () => {
  return useUserHasPermission({
    permissions: [AccountsPermissions.UPDATE_ACCOUNT],
  });
};
